<div class="flex items-center justify-center dialog-header ">
    Column Informations

    <div class="absolute right-2">
        <button
            (click)="handleCloseDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
  <div class="dashboard-container">
    <div
    style="color: red;
    font-weight: 600;
    margin-bottom: 21px;"
    >
      Note:- For the given column, the values listed in the table below are valid. 
      In your CSV/XLSX file, only these values are allowed for the corresponding column.
    </div>
    
    <div class="data-table">
      <!-- Iterate through dynamic data keys -->
      <div class="data-row" *ngFor="let key of getKeys(dynamicData)">
        <div class="data-key">{{ key }}</div>
        <div class="data-value">
          <ng-container *ngFor="let value of dynamicData[key]; let last = last">
            {{ value }}<span *ngIf="!last">, </span>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  
 
      
</div>